export default {"src":"/_next/static/media/quoteup.a5ea9f63.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};